import { css } from '@/styled-system/css';

export const containerStyles = css.raw({
  alignItems: 'center',
  borderRadius: '100',
  border: '1px solid {colors.border.subtle}',
  color: 'text.neutral',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  justifyContent: 'center',
  // oxlint-disable-next-line constellation/no-raw-spacing-values -- `minHeight: 240px` is past the end of the numeric sizes scale, which stops at `5000` (200px)
  minHeight: '240px',
  // oxlint-disable-next-line constellation/no-raw-spacing-values -- `maxHeight: 311px` is past the end of the numeric sizes scale, which stops at `5000` (200px)
  maxHeight: '311px',
  maxWidth: '100%',
  padding: '400',
  textAlign: 'center',
});
